import React from "react"

export const SiteLaunchSuccessImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="400"
      height="400"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M229.495 277.616C229.487 266.338 220.689 257.02 209.429 256.366C198.17 255.713 188.352 263.949 187.038 275.15C172.766 273.015 158.755 280.371 152.409 293.331C144.118 284.543 130.711 282.982 120.623 289.631C110.535 296.281 106.684 309.217 111.492 320.301C102.658 318.171 93.3346 320.207 86.1935 325.827C79.0523 331.447 74.8811 340.03 74.875 349.117C74.875 349.117 74.875 363.864 79.6417 369.524C74.875 374.283 76.9604 385.024 80.8334 386.2"
        fill="white"
      />
      <path
        d="M229.495 277.616C229.487 266.338 220.689 257.02 209.429 256.366C198.17 255.713 188.352 263.949 187.038 275.15C172.766 273.015 158.755 280.371 152.409 293.331C144.118 284.543 130.711 282.982 120.623 289.631C110.535 296.281 106.684 309.217 111.492 320.301C102.658 318.171 93.3346 320.207 86.1935 325.827C79.0523 331.447 74.8811 340.03 74.875 349.117C74.875 349.117 74.875 363.864 79.6417 369.524C74.875 374.283 76.9604 385.024 80.8334 386.2"
        stroke="#1D2B47"
      />
      <path
        d="M182.939 185.967L159.027 202.952C146.734 212.297 141.618 228.655 146.322 243.602L162.59 295.346C162.59 295.346 162.59 254.457 184.958 247.593C207.325 240.729 182.939 185.967 182.939 185.967V185.967Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M244.165 185.967L268.077 202.952C280.37 212.297 285.486 228.655 280.782 243.602L264.514 295.346C264.514 295.346 264.514 254.457 242.147 247.593C219.779 240.729 244.165 185.967 244.165 185.967Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M236.975 263.696L233.447 265.511C222.147 271.324 208.733 271.31 197.446 265.472L194.016 263.696V234.547H236.975V263.696Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path
        d="M184.923 247.24L171.595 137.394C168.526 117.896 173.978 98.0188 186.566 82.8156L214.762 48.7665C214.907 48.5904 215.123 48.4883 215.35 48.4883C215.578 48.4883 215.794 48.5904 215.938 48.7665L244.288 82.8705C256.89 98.0328 262.38 117.874 259.364 137.358L246.126 247.902L245.248 248.686C228.295 263.558 202.896 263.389 186.142 248.294L184.923 247.24Z"
        fill="#B99BF9"
        stroke="#1D2B47"
      />
      <path d="M215.501 115.054V197.558" stroke="#1D2B47" />
      <path
        d="M223.555 204.473L215.515 304.272L207.479 204.481C207.173 200.725 210.862 197.546 215.515 197.546C220.172 197.538 223.856 200.717 223.555 204.473Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <circle
        cx="215.502"
        cy="148.295"
        r="25.0566"
        fill="white"
        stroke="#1D2B47"
      />
      <circle
        cx="215.501"
        cy="148.295"
        r="18.079"
        fill="#2B5FCE"
        stroke="#1D2B47"
      />
      <path
        d="M218.102 130.404L199.109 155.927C200.34 158.562 202.186 160.862 204.492 162.635L226.075 133.627C223.718 131.922 220.981 130.816 218.102 130.404V130.404Z"
        fill="white"
      />
      <path
        d="M212.941 166.19L231.914 140.71C231.278 139.342 230.475 138.058 229.523 136.888L208.594 165.01C209.987 165.585 211.448 165.982 212.941 166.19Z"
        fill="white"
      />
      <circle cx="215.501" cy="148.295" r="18.079" stroke="#1D2B47" />
      <path
        d="M173.227 108.362C173.227 108.362 215.5 123.235 256.75 108.754"
        stroke="#1D2B47"
      />
      <path
        d="M238.703 157.754L249.589 156.304L247.202 188.354L253.238 188.307"
        stroke="#1D2B47"
      />
      <path
        d="M249.594 156.304C249.594 156.304 253.173 124.089 250.284 110.785"
        stroke="#1D2B47"
      />
      <path
        d="M247.203 188.354L242.942 233.712C242.942 233.712 232.06 242.019 220.539 241.87"
        stroke="#1D2B47"
      />
      <path
        d="M215.508 181.286C215.508 181.286 202.027 185.112 187.711 179.326"
        stroke="#1D2B47"
      />
      <path
        d="M173.227 149.471C173.227 149.471 181.576 155.453 185.496 154.089C186.351 164.998 190.439 206.88 190.439 206.88C190.439 206.88 182.564 207.448 179.616 203.434"
        stroke="#1D2B47"
      />
      <path d="M215.501 48.9154V13.8" stroke="#1D2B47" />
      <path
        d="M383.219 358.494C383.222 347.384 376.724 337.3 366.606 332.712C356.488 328.123 344.622 329.879 336.266 337.2C333.095 326.325 324.797 317.694 314.056 314.097C303.314 310.501 291.492 312.395 282.413 319.168C281.348 309.17 272.914 301.585 262.86 301.583C262.33 301.583 261.805 301.61 261.292 301.65C264.34 292.773 262.914 282.971 257.463 275.331C252.011 267.692 243.206 263.155 233.82 263.151"
        stroke="#1D2B47"
      />
      <path
        d="M75.3904 352.629C65.9537 347.59 54.2374 350.446 48.1778 359.262C43.0066 356.764 36.9146 357.1 32.0495 360.151C27.1844 363.202 24.2295 368.54 24.2266 374.283"
        stroke="#1D2B47"
      />
      <path
        d="M274.479 351.939C274.479 344.362 268.336 338.219 260.759 338.219C260.5 338.219 260.242 338.219 259.975 338.243C258.905 330.453 252.982 324.216 245.259 322.743C237.535 321.27 229.733 324.89 225.871 331.74C220.78 332.349 216.947 336.667 216.945 341.794"
        stroke="#1D2B47"
      />
      <path
        d="M149.045 347.784C149.045 345.023 147.455 342.51 144.961 341.326C142.467 340.142 139.514 340.5 137.375 342.245C134.381 340.502 130.683 340.493 127.68 342.221C124.677 343.948 122.827 347.15 122.828 350.614"
        fill="white"
      />
      <path
        d="M149.045 347.784C149.045 345.023 147.455 342.51 144.961 341.326C142.467 340.142 139.514 340.5 137.375 342.245C134.381 340.502 130.683 340.493 127.68 342.221C124.677 343.948 122.827 347.15 122.828 350.614"
        stroke="#1D2B47"
      />
      <path
        d="M36.4453 322.445V114.497H68.2443C77.9867 114.497 85.8843 122.395 85.8843 132.137C85.8843 139.827 92.1183 146.061 99.8082 146.061H122.826"
        fill="white"
      />
      <path
        d="M36.4453 322.445V114.497H68.2443C77.9867 114.497 85.8844 122.395 85.8844 132.137C85.8844 139.827 92.1183 146.061 99.8082 146.061H122.826"
        stroke="#1D2B47"
      />
      <path d="M89.1797 180.933H126.718H89.1797Z" fill="white" />
      <path d="M89.1797 180.933H126.718" stroke="#1D2B47" />
      <path d="M89.1797 222.046H126.718H89.1797Z" fill="white" />
      <path d="M89.1797 222.046H126.718" stroke="#1D2B47" />
      <path d="M89.1797 263.159H126.718H89.1797Z" fill="white" />
      <path d="M89.1797 263.159H126.718" stroke="#1D2B47" />
      <path d="M89.1804 154.12V297.718V154.12Z" fill="white" />
      <path d="M89.1804 154.12V297.718" stroke="#1D2B47" />
      <path
        d="M54.3203 154.12H69.2163V169.016H54.3203V154.12Z"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path d="M61.7663 130.287V304.272V130.287Z" fill="#1D2B47" />
      <path d="M61.7663 130.287V304.272" stroke="#1D2B47" />
      <path
        d="M16.7812 350.136V290.038C16.7834 283.915 21.7472 278.951 27.8709 278.949H38.7607C41.7043 278.946 44.5284 280.112 46.6113 282.192C48.6942 284.272 49.865 287.095 49.8661 290.038V334.593"
        fill="white"
      />
      <path
        d="M16.7812 350.136V290.038C16.7834 283.915 21.7472 278.951 27.8709 278.949H38.7607C41.7043 278.946 44.5284 280.112 46.6113 282.192C48.6942 284.272 49.865 287.095 49.866 290.038V334.593"
        stroke="#1D2B47"
      />
      <path
        d="M324.531 304.272V185.998H350.599C356.602 185.998 361.469 190.862 361.473 196.864V223.677C361.473 229.682 366.342 234.551 372.347 234.551C375.233 234.551 378 235.698 380.039 237.739C382.079 239.78 383.224 242.548 383.221 245.433V314.401"
        fill="white"
      />
      <path
        d="M324.531 304.272V185.998H350.599C356.602 185.998 361.469 190.862 361.473 196.864V223.677C361.473 229.682 366.342 234.551 372.347 234.551C375.233 234.551 378 235.698 380.039 237.739C382.079 239.78 383.224 242.548 383.221 245.433V314.401"
        stroke="#1D2B47"
      />
      <path d="M324.536 210.933H301H324.536Z" fill="white" />
      <path d="M324.536 210.933H301" stroke="#1D2B47" />
      <path d="M324.536 234.559H301H324.536Z" fill="white" />
      <path d="M324.536 234.559H301" stroke="#1D2B47" />
      <path d="M324.536 258.185H301H324.536Z" fill="white" />
      <path d="M324.536 258.185H301" stroke="#1D2B47" />
      <path
        d="M361.773 310.826V249.753C361.773 247.614 363.507 245.88 365.646 245.88C367.785 245.88 369.519 247.614 369.519 249.753V321.253"
        fill="white"
      />
      <path
        d="M361.773 310.826V249.753C361.773 247.614 363.507 245.88 365.646 245.88C367.785 245.88 369.519 247.614 369.519 249.753V321.253"
        stroke="#1D2B47"
      />
      <path
        d="M325.834 53.3137C325.834 49.0109 327.352 44.8461 330.122 41.5537C321.74 41.916 314.675 47.9275 312.975 56.1443C311.275 64.361 315.376 72.682 322.927 76.3403C330.478 79.9985 339.549 78.0586 344.944 71.6319C344.681 71.6319 344.419 71.6319 344.16 71.6319C339.3 71.6339 334.639 69.7049 331.202 66.2694C327.765 62.8338 325.834 58.1733 325.834 53.3137Z"
        fill="#1947AA"
        stroke="#1D2B47"
      />
      <circle
        cx="155.762"
        cy="34.8035"
        r="3.42608"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <circle
        cx="320.809"
        cy="128.053"
        r="3.42608"
        fill="#1D2B47"
        stroke="#1D2B47"
      />
      <path d="M279.469 23.9294V31.2285V23.9294Z" fill="#1D2B47" />
      <path d="M279.469 23.9294V31.2285" stroke="#1D2B47" />
      <path d="M275.82 27.5791H283.119H275.82Z" fill="#1D2B47" />
      <path d="M275.82 27.5791H283.119" stroke="#1D2B47" />
      <path d="M140.938 104.666V111.965V104.666Z" fill="#1D2B47" />
      <path d="M140.938 104.666V111.965" stroke="#1D2B47" />
      <path d="M137.289 108.315H144.588H137.289Z" fill="#1D2B47" />
      <path d="M137.289 108.315H144.588" stroke="#1D2B47" />
      <path d="M369.446 110.922V118.221V110.922Z" fill="#1D2B47" />
      <path d="M369.446 110.922V118.221" stroke="#1D2B47" />
      <path d="M365.797 114.571H373.096H365.797Z" fill="#1D2B47" />
      <path d="M365.797 114.571H373.096" stroke="#1D2B47" />
      <path d="M69.1413 34.6545V41.9536V34.6545Z" fill="#1D2B47" />
      <path d="M69.1413 34.6545V41.9536" stroke="#1D2B47" />
      <path d="M65.4922 38.3042H72.7912H65.4922Z" fill="#1D2B47" />
      <path d="M65.4922 38.3042H72.7912" stroke="#1D2B47" />
    </svg>
  )
}
